module.exports = __webpack_public_path__ + "static/banner-763792feb7e0d3918af53bed1aaa4c37.jpg";